<template>
  <div class="staging-banner noprint" data-cy="staging-banner">
    <div class="container flex justify-content-between align-items-center">
      <p class="body-5" data-cy="banner-version"></p>
      <a :href="mailtoLink" data-cy="report-issue-link" target="_blank">
        Report an issue
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { BuildInfo } from "@/injectionKeys";
import type { PropType } from "vue";

const props = defineProps({
  buildInfo: {
    type: Object as PropType<BuildInfo>,
    default: () => ({
      BUILD_ID: null
    })
  }
});

const { buildInfo } = props;
const subject = `Issue on build ${buildInfo.GIT_COMMIT ?? "Unknown"}:`;
const mailtoLink = `mailto:SGSupport@Halliburton.com?subject=${encodeURIComponent(subject)}`;
</script>

<style lang="scss" scoped>
.staging-banner {
  font-size: 11px;
  background: var(--surface-400);
  min-height: 25px;
  display: flex;

  .bigger {
    font-size: 10;
    font-weight: 600;
  }

  .build {
    font-weight: 300;
  }

  .branch {
    font-style: italic;
  }
}
</style>
